// Modules
import React from "react";
import _ from "lodash";
import { connect } from "react-redux";
import alarm from "assets/audio/alarm.mp3";

// Services
import Triage from "services/data/triage";

// Actions
import { useTriageItems } from "modules/triage/store/actions";

// Components
import TriageItem from "components/models/triage/triage-items";
import FlipMove from "components/widgets/animation/flip-move";
import SVG from "components/widgets/icons/svg";
import Clock from "components/widgets/dates/clock";

// Constants
import { isMobile } from "constants";

function TriageList(props) {
  const { user } = props;
  // Renders the items, so it owns a subscription of its own. Nothing interacts
  // with a wall dashboard, so its gate never holds and updates land immediately —
  // which is what you want on a display nobody is working in.
  const { items } = useTriageItems({ user, socket: true });

  const sorted = _(items)
    .reject({ status: "Archived" })
    .orderBy([Triage.getSortKey], ["desc"])
    .value();

  const duration = isMobile ? 200 : 500;

  return (
    <div className="triage-dashboard">
      <audio id="triage-audio" src={alarm} autoPlay={false}></audio>
      <div className="clock-wrapper">
        <SVG src="svg/triage.svg" />
        <Clock format="h:mm A M/D" />
      </div>
      <FlipMove duration={duration}>
        {_.map(sorted, (item) => (
          <div key={item.triageId}>
            <TriageItem item={item} onDashboard />
          </div>
        ))}
      </FlipMove>
    </div>
  );
}

// Exports
export default connect((state) => ({
  user: state.auth.currentUser
}))(TriageList);
